import { render } from "./LinkList.vue?vue&type=template&id=4ab0ea7a&scoped=true"
const script = {}

import "./LinkList.vue?vue&type=style&index=0&id=4ab0ea7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab0ea7a"]])

export default __exports__